import React from "react";
import { createRoot } from "react-dom/client";
import { VideoPlayer } from "./VideoPlayer";

export const setupCloudinaryVideoPlayer = (element) => {
  const dataset = element.dataset;
  const {
    autoplay,
    controlColour,
    controls,
    loop,
    muted,
    poster,
    publicId,
  } = dataset;

  const root = createRoot(element);
  root.render(
    <VideoPlayer
      id="cdnVideoPlayer"
      autoplay={autoplay}
      controlColour={controlColour}
      controls={controls}
      loop={loop}
      muted={muted}
      poster={poster}
      publicId={publicId}
    />
  );
};
